let fs: any;
let path: any;
if (typeof window === 'undefined')
{
    fs = require('fs');
    path = require('path');
}
export class FileOperation
{
    static findUp(fileName: string): string[]
    {
        let currentDir: string = __dirname;
        const rootDir: string = process.cwd();
        const foundFilePaths: string[] = [];
        function searchRecursively(dir: string)
        {
            const files: string[] = fs.readdirSync(dir);
            if (files.includes(fileName))
                foundFilePaths.push(path.join(dir, fileName));
            if (rootDir === dir)
                return;
            let new_dir = path.dirname(dir);
            if (new_dir == dir)
                return;
            searchRecursively(new_dir);
        }
        searchRecursively(currentDir);
        return foundFilePaths;
    }
    static async foreach(base: string, handler: (base: string, sub: string, name: string, full: string, isFolder: boolean) => Promise<boolean>, folders: boolean = true, files: boolean = true)
    {
        async function recursive(base: string, sub: string)
        {
            let names = fs.readdirSync(path.join(base, sub));
            for (let name of names)
            {
                let newSub = path.join(sub, name)
                let full = path.join(base, newSub);
                if (fs.statSync(full).isDirectory())
                {
                    if (folders)
                    {
                        let moveon = await handler(base, sub, name, full, true);
                        if (!moveon)
                            continue;
                    }
                    await recursive(base, newSub);
                }
                else
                {
                    if (files)
                        await handler(base, sub, name, full, false);
                }
            }
        }
        await recursive(base, "");
    }
}